import { Card, Button, ProgressInfo } from '@chikara/ui';
import { formatCurrency } from '@chikara/utils';
import { Card as CardType } from '@/features/card/types/card.types';
import { isBasic } from '@/shared/config/permissions';
import { useAuth } from '@/features/auth/hooks/useAuth';
import styles from '../../pages/CardDetailPage/CardDetailPage.module.css';
import { t } from '@/i18n';

interface CardDetailFinancialProps {
    card: CardType;
    onManageLimit: () => void;
}

const formatMXN = (value: number) => formatCurrency(value, { locale: 'es-MX', currency: 'MXN' });

export const CardDetailFinancial = ({ card, onManageLimit }: CardDetailFinancialProps) => {
    const { userData } = useAuth();
    const basic = isBasic(userData.role);
    const spent = card.creditLimit - card.disposable;

    return (
        <div className={styles.financialSection}>
            <Card>
                <Card.Stats
                    label={t('dashboard.card.detail.financial.limit')}
                    value={card.creditLimitParse}
                    action={
                        !basic ? (
                            <Button
                                variant="link-secondary"
                                size="sm"
                                onClick={onManageLimit}
                                disabled={card.card_status === 'disabled'}
                            >
                                {t('dashboard.card.detail.financial.manage')}
                            </Button>
                        ) : undefined
                    }
                />
            </Card>
            <Card className={styles.progressCard}>
                <Card.Stats
                    className={styles.progressStats}
                    value={
                        <div style={{ width: '100%' }}>
                            <ProgressInfo
                                total={card.creditLimit}
                                spent={spent}
                                formatValue={formatMXN}
                            />
                        </div>
                    }
                />
            </Card>
        </div>
    );
};
